class ProudctPageForm extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.onSubmit.bind(this));
        this.submitButton = this.form.querySelector('.submitClass');
    }
    onSubmit(event) {
        event.preventDefault();
        this.submitButton.classList.add("show");
        let PorductformData = new FormData(this.form);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = PorductformData;
        fetch(`${window.Shopify.routes.root}cart/add`, config)
            .then(response => {
                return response.json();
            }).then((response) => {
                if (response.status) {
                    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
                    if (!this.errorMessageWrapper) return;
                    this.errorMessage = this.errorMessageWrapper.querySelector('.product-form__error-message');
                    this.errorMessageWrapper.toggleAttribute('hidden', !this.errorMessage);
                    if (this.errorMessageWrapper) {
                        this.errorMessage = this.errorMessageWrapper.querySelector('.product-form__error-message');
                        if (this.errorMessage) {
                            this.errorMessage.textContent = response.description;
                        }
                    }
                    this.submitButton.classList.remove("show");

                } else {


                    /*    if (!this.errorMessageWrapper.hasAttribute("hidden")) {
    this.errorMessageWrapper.setAttribute('hidden',''); 
}*/
                    let cartAjax = new Cart();
                    cartAjax.fetchData();
                    this.submitButton.classList.remove("show");

                }
            }).catch((error) => {
                console.error('Error:', error);
            });

    }
}
customElements.define('product-form', ProudctPageForm);

class VariantDropdown extends HTMLElement {
    constructor() {
        super();
        this.dropdownMenus = this.querySelectorAll('.productpageopitons');
        this.selectmenuinventory = this.querySelector(`#Variants-${this.dataset.section}`);
        this.purl = this.getAttribute('pro-url');                     
         this.variantbox  = this.querySelectorAll('.variant-swatch-box'); 
        this.addToCartBtn = this.querySelector('.submitClass');
        this.oneclickcheckout = this.querySelector('.oneclickcheckout');
        this.buyItNowBtn = this.querySelector('.buy-now');
        this.addEventListener('change', this.handleOptionChange);
    }
    handleOptionChange(event) {
      var targetElement = event.target;
  console.log(targetElement.value);
 /* var $parentElement = $(targetElement).closest('.variant-color');

  if ($parentElement.length) {
    // Retrieve the previously stored class from the data attribute
    var previousClass = $parentElement.data('selected-class');
    
    // If there is a previous class, remove it
    if (previousClass) {
      $parentElement.removeClass(previousClass);
    }

    // Add the new class
    var newClass = targetElement.value;
    $parentElement.addClass(newClass);

    // Store the new class in the data attribute
    $parentElement.data('selected-class', newClass);
  }*/
var parentElement = targetElement.closest('.variant-color');

if (parentElement) {
  // Retrieve the previously stored class from the dataset
  var previousClass = parentElement.dataset.selectedClass;

  // If there is a previous class, remove it
  if (previousClass) {
    parentElement.classList.remove(previousClass);
  }

  // Add the new class
  var newClass = targetElement.value;
  parentElement.classList.add(newClass);

  // Store the new class in the dataset
  parentElement.dataset.selectedClass = newClass;
}

          var closestVariantWrapper = targetElement.closest('.variant_wrapper');    
      console.log(closestVariantWrapper)
          if (closestVariantWrapper) {
      closestVariantWrapper.classList.remove('show_color');
          }
         var closestWholeVariantWrapper = targetElement.closest('.vaiant-swatch-block'); 
       if (closestWholeVariantWrapper) {
      closestWholeVariantWrapper.classList.remove('active-block');
          }
        this.getOptionsAndid();
        this.SetAddtoCartButton();
        this.updatepickupAvailibity();
        this.updateURL();
        this.updateVariantStatuses()
        if (!this.currentVariant) {} else {

            this.setVariant();
            this.renderPrice();
            this.updateProductslider();

        }
     
    }
    getOptionsAndid() {    

      const selectedOptions = []; 
       this.dropdownMenus.forEach(dropdownMenu=> {
            if (dropdownMenu.type === 'radio') {
                if (dropdownMenu.checked) {
                  console.log(dropdownMenu);
                   //setTimeout(() => {BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false, false)},1000)
                  setTimeout(() => {
                    try {
                        BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false, false);
                    } catch (error) {
                        console.error("Error in changeProductPrice:", error);
                    }
                }, 1000);

                    selectedOptions.push(dropdownMenu.value);                 
                }
            } else {
                selectedOptions.push(dropdownMenu.value);
            }
        });

        this.currentVariant = Productpage.find((variant) => {
            return !variant.options.map((option, index) => {
                return selectedOptions[index] === option;
            }).includes(false);
        });
    }
    setVariant() {
        const form = document.querySelector(`#product-addtocartform-${this.dataset.section}`);
        form.querySelector('input[name=id]').value = this.currentVariant.id;
    }
   updateVariantStatuses() {
     //BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false, false)
try {
    if (BSS_B2B?.cp?.changeProductPrice) {
        BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false, false);
    } else {
        console.warn("changeProductPrice function is not available");
    }
} catch (error) {
    console.error("Error in changeProductPrice:", error);
}

/*  const selectedOptionOneVariants = Productpage.filter(variant => this.querySelector('.variant-swatch-box :checked').value === variant.option1);
  let variants = Productpage;
     const inputWrappers = [...this.querySelectorAll('.vaiant-swatch-block')];
   inputWrappers.forEach((option, index) => {
     if (index === 0) return;
     const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index].querySelector(':checked').value;
 const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index  }`]);

      });

  let variants = Productpage;
  let variantOptions = document.querySelectorAll('.productpageopitons');
  
        const selectedOptionValues = []; 
       this.dropdownMenus.forEach(dropdownMenu=> {
            if (dropdownMenu.type === 'radio') {
                if (dropdownMenu.checked) {
                    selectedOptionValues.push(dropdownMenu.value);                 
                }
            } else {
                selectedOptionValues.push(dropdownMenu.value);
            }
        });
  for (let i = 0; i < variantOptions.length; i++) {
    let variantOption = variantOptions[i];
    let optionValue = variantOption.value;
    let nextElement = variantOption.nextElementSibling;

    let availableVariants = variants.filter(function(variant) {
      return variant.available && variant.options.slice(0, i).join() === selectedOptionValues.slice(0, i).join();
    });
    let availableOptionValues = availableVariants.map(function(variant) {
      return variant.options[i];
    });
    console.log(availableOptionValues)

 if (availableOptionValues.length === 0 || availableOptionValues === undefined) {
  console.log("No available variants found.");
  break;
}

 
    if (availableOptionValues.includes(optionValue)) {
      if (nextElement) { 
  nextElement.classList.add("optiondisabled");
}
    } else {
      if (nextElement) { 
  nextElement.classList.remove("optiondisabled");
}
    }
  }
  */
}



    updateProductslider() {
        if (this.currentVariant.featured_media && main) {
            main.go(this.currentVariant.featured_media.position - 1);
            BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false, false)
        }
    }
    SetAddtoCartButton() {
        const form = document.querySelector(`#product-addtocartform-${this.dataset.section}`);
        const addToCartBtn = form.querySelector('.submitClass');
        const buyItNowBtn = form.querySelector('.buy-now');      
        const oneclickcheckout = form.querySelector('.oneclickcheckout'); 
     if (this.currentVariant && this.currentVariant.available) {  
       if(addToCartBtn){
             addToCartBtn.removeAttribute('disabled');
          addToCartBtn.querySelector('.AddCarttext').textContent  = window.variantStrings.addToCart;
       }
          if(oneclickcheckout){
          oneclickcheckout.removeAttribute('disabled')
          oneclickcheckout.querySelector('.AddCarttext').textContent  = window.variantStrings.onecheckout;
        }
        } else {
       if(addToCartBtn){
            addToCartBtn?.setAttribute('disabled', 'disabled');
           addToCartBtn.querySelector('.AddCarttext').textContent  = window.variantStrings.soldOut;
       }
          if(oneclickcheckout){
            oneclickcheckout.setAttribute('disabled', 'disabled');
          oneclickcheckout.querySelector('.AddCarttext').textContent  = window.variantStrings.soldOut;
          }
        }     
      if (!this.currentVariant) {                 
       form.querySelector('.AddCarttext').textContent  = window.variantStrings.unavailable;      
      }


    }

    updateURL() {
        if (!this.currentVariant || this.purl === 'false') return;
        window.history.replaceState({}, '', `${this.purl}?variant=${this.currentVariant.id}`);
    }

    renderPrice() {
        const removeSpaces = str => str.replace(/\s/g, '');
        fetch(`${this.purl}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                let picehtml = new DOMParser().parseFromString(responseText, 'text/html');
                //var picehtmlprice = new DOMParser().parseFromString(responseText, 'text/html');                
                var PricedataProductPage = picehtml.querySelector(`#price-${this.dataset.section}`).innerHTML;
                document.querySelector(`#price-${this.dataset.section}`).innerHTML = PricedataProductPage;
                let myAddtocartbuttonstatus = picehtml.querySelector('.submitClass');
            
            });
    }
    updatepickupAvailibity() {
        if (this.currentVariant && this.currentVariant.available) {
            pickup1.fetchPickupAvailability(this.currentVariant.id);
        } else {
            if (document.querySelector('.pickup-availability-information')) {
                document.querySelector('.pickup-availability-information').innerHTML = '';
            }
        }
    }

}
customElements.define('variant-block', VariantDropdown);

var Pickupid = document.querySelector('.product-single__store-availability-container').getAttribute("data-has-only-default-variant");
class PickUp {
    constructor() {
        this.fetchPickupAvailability(Pickupid);
    }
    fetchPickupAvailability(id) {
        fetch(window.Shopify.routes.root + `variants/${id}/?section_id=pickup-availability`)
            .then(response => response.text())
            .then(text => {
                const container = document.querySelector('[data-store-availability-container]');
                container.innerHTML = '';
                const pickupAvailabilityHTML = new DOMParser()
                    .parseFromString(text, 'text/html')
                    .querySelector('.pickup-availability-container');
                container.appendChild(pickupAvailabilityHTML);              
                this.openpopup();
            })
            .catch(e => {
                console.error(e);
            });
    }
    openpopup() {
        const PopUpPickUp = document.querySelectorAll('.pickup-availability-information__button');
        if (PopUpPickUp.length > 0) {
            PopUpPickUp[0].addEventListener('click', (event) => {
                event.preventDefault();
                
                const slidePickUp = document.getElementById("PickupAvailabilityModal");
                const wholePickupHtml = slidePickUp.querySelector('#mylocaton').innerHTML;                
                document.querySelector("#slide_pickup .offcanvas-body").innerHTML = wholePickupHtml;
            });
        }
    }
}
const pickup1 = new PickUp();

class StickyAddToCart extends HTMLElement {
    constructor() {
        super();
        this.dropdownMenus = this.querySelectorAll('.stickyproductpageopitons');
        this.addToCartBtn = this.querySelector('.stickysubmit');
         this.addToCartBtntext = this.querySelector('.stickysubmit .AddCarttext');      
        this.oneclickCheckout = this.querySelector('.oneclickcheckout');
      this.oneclickCheckouttext = this.querySelector('.oneclickcheckout .AddCarttext');
        this.form = this.querySelector(`#product-stickyaddtocartform-${this.dataset.section}`);
        this.addEventListener('change', this.onChange);
        this.submit();
    }
    onChange(event) {
        const selectedOptions = [];
        this.dropdownMenus.forEach(dropdownMenu => {
            if (dropdownMenu.type === 'radio') {
                if (dropdownMenu.checked) {
                    selectedOptions.push(dropdownMenu.value);
                }
            } else {
                selectedOptions.push(dropdownMenu.value);
            }
        });        
        //  console.log(selectedOptions)
        this.currentVariant = Productpage.find((variant) => {
            return !variant.options.map((option, index) => {
              console.log(option);
                return selectedOptions[index] === option;
            }).includes(false);
        });
       console.log(this.currentVariant)
        if (this.currentVariant && this.currentVariant.available) { 
          if(this.addToCartBtn){
            this.addToCartBtn.disabled = false;
          this.addToCartBtntext.textContent  = window.variantStrings.addToCart;
          }
          if(this.oneclickCheckout){
          this.oneclickCheckout.disabled = false;
          this.oneclickCheckouttext.textContent  = window.variantStrings.onecheckout;
        }
        } else {
          if(this.addToCartBtn){
            this.addToCartBtn.disabled = true;
           this.addToCartBtntext.textContent  = window.variantStrings.soldOut;
          }
          if(this.oneclickCheckout){
            this.oneclickCheckout.disabled = true;           
          this.oneclickCheckouttext.textContent  = window.variantStrings.soldOut;          
          }
        }
       if (!this.currentVariant) {   
           this.querySelector('.AddCarttext').textContent  = window.variantStrings.unavailable;   
      }
        if (this.currentVariant) {                
            this.form.querySelector('input[name=id]').value = this.currentVariant.id;
        }
        if (this.currentVariant && this.currentVariant.featured_image) {  
         this.querySelector('.stickyproductimage').src = this.currentVariant.featured_image.src;
        } 
        if (this.currentVariant) {           
       let stickySelect =  this.querySelector('.stickyselect');        
       let option = stickySelect.querySelector(`option[value="${this.currentVariant.id}"]`);
       let regPrice = option.getAttribute('price')
       if (this.querySelector('.sticky-product-compare-price')) {   
       if (option.hasAttribute("compare-price")) {
       let comPrice = option.getAttribute('compare-price');
       this.querySelector('.sticky-product-compare-price').textContent = comPrice;
       }else{
       this.querySelector('.sticky-product-compare-price').textContent = '';
       }
       }  
       this.querySelector('.sticky-product-regular-price ').textContent = regPrice;          
       }
          
    }
    submit() {
        this.form.addEventListener('submit', (evt) => {
            evt.preventDefault();
            this.addToCartBtn.classList.add("show");
            let formData = new FormData(this.form);
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            
            config.body = formData;
            fetch(`${window.Shopify.routes.root}cart/add`, config)
                .then((response) => {
                    return response.json();
                })
                .then((response) => {
                    if (response.status) {
                        alert(response.description);
                        this.addToCartBtn.classList.remove("show");
                    } else {
                        let cartAjax = new Cart();
                        cartAjax.fetchData();
                        this.addToCartBtn.classList.remove("show");
                    }
                })
                .catch((e) => {
                    console.error(e);
                });

        });
    }
}
customElements.define('sticky-addto-cart', StickyAddToCart);


const submitClass = document.querySelector('.pfb-main');
const StickyClass = document.querySelector('.sticky-add-to-cart');

if (submitClass && StickyClass) {
  window.addEventListener("scroll", function() {
      if (submitClass.getBoundingClientRect().bottom <= 0) {
          StickyClass.style.display = "block";
      } else {
          StickyClass.style.display = "none";
      }
  });
}
/*const submitClass = document.querySelector('.pfb-main');
const StickyClass = document.querySelector('.sticky-add-to-cart');

if (submitClass && StickyClass) {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        StickyClass.style.display = "none";
      } else {
        StickyClass.style.display = "block";
      }
    });
  });

  observer.observe(submitClass);
}*/

    const getFormData = onclickcheckoutform => {      
      let oneClickVid = onclickcheckoutform.querySelector('input[name="id"]').value;      
      let oneclickqty = Number(onclickcheckoutform.querySelector('input[name="quantity"]').value || 1);
      let onedeleiverydat = onclickcheckoutform.querySelector('input[name="properties[Deliever Date]"]').value; 
      let onedeleiverytime = onclickcheckoutform.querySelector('input[name="properties[Deliever Time]"]').value; 
      return { oneClickVid, oneclickqty ,onedeleiverydat ,onedeleiverytime};
    };

    document.querySelectorAll('.oneclickcheckout').forEach(oneclick => {
      oneclick.addEventListener('click', event => {        
        event.preventDefault();      
        const form = oneclick.closest('form[action="/cart/add"]');
         const CheckoutformData = new FormData(form);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = CheckoutformData;
        console.log(config);
         fetch(`${window.Shopify.routes.root}cart/add`, config)
        .then((response) => {
                 window.location.href = `/checkout/`;
                }).catch((e) => {
                    console.error(e);
                });
             });
    });


